import { DriveItemSearchResult } from "../../interfaces/IDriveItemSearchResult";
import { IGraphSearchResult } from "../../interfaces/IGraphSearchResult";
import { IMapper } from "../../interfaces/IMapper";

export class DriveSearchResultMapper implements IMapper<IGraphSearchResult> {
    map(data: any[]): IGraphSearchResult {
        const noResultsAvailable = data.length !== 1 || !data[0].hitsContainers[0].hits;
        return noResultsAvailable ?
            { moreResultsAvailable: false, driveItems: [] } :
            { moreResultsAvailable: data[0].hitsContainers[0].moreResultsAvailable, driveItems: data[0].hitsContainers[0].hits.map(item => this.mapDriveItems(item)) };
    }

    private mapDriveItems = (item): DriveItemSearchResult => {
        return {
            id: item.resource?.id,
            name: item.resource?.name,
            driveId: item.resource?.parentReference.driveId,
            createdDateTime: item.resource?.createdDateTime,
            lastModifiedDateTime: item.resource?.lastModifiedDateTime,
            modifiedBy: item.resource?.lastModifiedBy?.user?.displayName,
            webUrl: item.resource?.webUrl,
            siteId: item.resource?.parentReference?.siteId,
            size: item.resource?.size,
            rank: item.rank,
            isDocument: item.resource?.listItem?.fields?.isDocument || !item.resource?.listItem?.fields?.isContainer,
            contentTypeId: item.resource?.listItem?.fields?.contentTypeID
        };
    };
}